import React from 'react'
import { GiftOrdersList } from './list/page'
export const GiftOrdersPage = () => {
  return <GiftOrdersList />
}
